// Dev-only error logging: nothing is written to the console in production builds.
export const logError = (where, error) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`[${where}]`, error);
  }
};

export default logError;
